(function () {
    const init = (root) => {
        const loader = root.querySelector('[data-vertical-flow-grid-loader]');
        const grid = root.querySelector('[data-vertical-flow-grid-body]');
        const infoRows = parseInt(root.getAttribute('data-vertical-flow-grid-info-rows'));

        const getImageSizes = () => {
            const result = {};
            const src = root.getAttribute("data-image-widths").split(',');
            for (let i = 0; i < src.length; i++) {
                const size = src[i].split(':');
                result[size[0]] = parseInt(size[1]);
            }
            return result;
        };
        const imageWidths = getImageSizes();
        const getCurrentImageWidth = () => {
            const winWidth = window.innerWidth;
            const map = [['xs', 0], ['sm', 576], ['md', 768], ['lg', 992], ['xl', 1200], ['xxl', 1400]];
            let index = 'xs';
            for (let i = 0; i < map.length; i++) {
                if (map[i][1] < winWidth) {
                    index = map[i][0];
                }
            }
            return imageWidths[index];
        };

        const images = grid.querySelectorAll("img");

        const getCell = (child) => {
            if (child.parentNode.classList.contains("verticalFlowGrid__cell")) {
                return child.parentNode;
            }
            return getCell(child.parentNode);
        };

        const setGridRowEnd = (image, imageWidth) => {
            getCell(image).style.gridRowEnd = 'span ' + (Math.ceil(image.naturalHeight * imageWidth / image.naturalWidth / 25) + infoRows);
        };
        const setGridRowEnds = () => {
            const imageWidth = getCurrentImageWidth();
            for (let i = 0; i < images.length; i++) {
                const image = images[i];
                if (image.complete && image.naturalHeight > 0) {
                    setGridRowEnd(image, imageWidth);
                } else {
                    image.onload = function () {
                        setGridRowEnd(this, imageWidth);
                    }
                }
            }
            grid.removeAttribute("hidden");
            loader.setAttribute("hidden", true);
        };
        setGridRowEnds();
        let timeout = 0;
        window.addEventListener('resize', () => {
            clearTimeout(timeout);
            timeout = setTimeout(setGridRowEnds, 100);
        });
    };

    window.addEventListener('load', () => {
        document.querySelectorAll("[data-vertical-flow-grid]").forEach(init);
    });

})();
